export default __webpack_public_path__ + "static/media/Return-Policy.de6e5597.jpg";